import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import Download from '../../MainSection/Download/Download';
import AddModuleField from './AddModuleField';
import ModuleFieldTable from './ModuleFieldTable';
import { useDispatch, useSelector } from 'react-redux';
import { loadAssignedModulesDropdownData, loadModuleFieldModulesDropdownData, loadModuleNameDropdownDataForSystemLogging, loadSettingsModuleFieldData, loadSettingsSingleModuleFieldData } from '../../../redux/action';

const statusOptions = [
    { value: "All", label: "All" },
    { value: "Pending", label: "Pending" },
    { value: "In-Process", label: "In-Process" },
    { value: "Resolved", label: "Resolved" },
    { value: "Re-Open", label: "Re-Open" },
    { value: "Cancel", label: "Cancel" },
]
const ModuleField = () => {
    let dispatch = useDispatch();

    const { getModuleFieldData } = useSelector((state) => state.data);
    const { getModuleFieldModuleDropdownData } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);
    const { getSingleModuleFieldData } = useSelector((state) => state.data);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [moduleFieldID, setModuleFiledID] = useState("")
    const [selectedModule, setSelectedModule] = useState('');

    const moduleFieldData = () => {
        dispatch(loadSettingsModuleFieldData(setLoading, rowsPerPage, page + 1, selectedModule));
    }
    useEffect(() => {
        moduleFieldData();
    }, [page, rowsPerPage, selectedModule]);

    useEffect(() => {
        dispatch(loadModuleFieldModulesDropdownData())
    }, []);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = (moduleFieldId) => {
        setIsModalOpen(true);
        if (moduleFieldId) {
            dispatch(loadSettingsSingleModuleFieldData(moduleFieldId))
            setModuleFiledID(moduleFieldId);
        } else {
            setModuleFiledID("");
        }
    };

    const handleModuleSelection = (selectedOption) => {
        if (selectedOption) {
            const moduleName = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedModule(moduleName);  // Store StatusID in state
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleClearFilters = () => {
        setSelectedModule('');
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Module Field"
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Module Field</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                {/* <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3}>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        // options={statusOptions}
                                        style={{ width: "100%" }}
                                    />
                                </Col> */}
                                <Col md={3}>
                                    <Select
                                        className="react-select-container complaint-status-select"
                                        classNamePrefix="react-select"
                                        placeholder="Select Modules"
                                        options={getModuleFieldModuleDropdownData}
                                        style={{ width: "100%" }}
                                        value={selectedModule ? getModuleFieldModuleDropdownData.find(module => module.value === selectedModule) : null}
                                        onChange={(selectedOption) => handleModuleSelection(selectedOption)}
                                    />
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <ModuleFieldTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                loading={loading}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                totalDataCount={totalDataCount}
                                getModuleFieldData={getModuleFieldData}
                                moduleFieldID={moduleFieldID}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddModuleField
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    moduleFieldData={moduleFieldData}
                    moduleFieldID={moduleFieldID}
                    getSingleModuleFieldData={getSingleModuleFieldData}
                />
            }
            {/* {showColumnFilterModal && (
                <CustomerFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                />
            )}
            {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default ModuleField;